/**
 * @generated SignedSource<<92e6dcc7af767958c9f4d0676fce30d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StripeButtonsBillingFragment$data = {
  readonly accounts: ReadonlyArray<{
    readonly slug: string;
  }>;
  readonly " $fragmentType": "StripeButtonsBillingFragment";
};
export type StripeButtonsBillingFragment$key = {
  readonly " $data"?: StripeButtonsBillingFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"StripeButtonsBillingFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StripeButtonsBillingFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "accounts",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "782fee05aedeacc2fc4e620057d9ee15";

export default node;
